(() => {
  console.log("✅ variant-media-filter.js RUNNING (public_title MODE + swiper fix)");

  const ALT_SHOW_ALL = "all";
  const DEBUG = true;

  const norm = (s) => (s || "").toString().trim().toLowerCase();
  const dlog = (...a) => DEBUG && console.log("[variant-media-filter]", ...a);

  function getSelectedVariantId() {
    return (
      document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
      null
    );
  }

  function getVariant() {
    const product = window.ShopifyAnalytics?.meta?.product;
    const variantId = getSelectedVariantId();
    if (!product?.variants?.length || !variantId) return null;

    return product.variants.find((v) => String(v.id) === String(variantId)) || null;
  }

  // ✅ Color is ALWAYS first part of public_title: "Tradewinds / Single"
  function getSelectedColor() {
    const v = getVariant();
    if (!v) return null;

    const pt = v.public_title || "";
    if (pt && pt.includes(" / ")) return pt.split(" / ")[0].trim();
    if (pt) return pt.trim();

    // fallback if public_title missing
    const name = v.name || v.title || "";
    if (name.includes(" / ")) {
      // "Oxygen Sleep Set – Tradewinds / Single" -> left of /
      const left = name.split(" / ")[0];
      // take after dash if exists
      const dashSplit = left.split("–");
      return (dashSplit[dashSplit.length - 1] || left).trim();
    }
    return null;
  }

  function isVideoSlide(slide) {
    if (!slide) return false;
    const mediaType = slide.getAttribute("data-media-type") || slide.dataset?.mediaType || "";
    if (mediaType === "video" || mediaType === "external_video" || mediaType.includes("video")) return true;
    if (
      slide.classList.contains("media-type-video") ||
      slide.classList.contains("media-type-external_video") ||
      slide.classList.contains("m-product-media--video") ||
      slide.classList.contains("m-product-media--external_video")
    ) {
      return true;
    }
    return Boolean(
      slide.querySelector(
        ".media-type-video, .media-type-external_video, .m-product-media--video, .m-product-media--external_video, [data-media-type*='video'], deferred-media, video, iframe"
      )
    );
  }

  function altMatches(altRaw, selectedRaw) {
    const parts = (altRaw || "")
      .split("|")
      .map((s) => s.trim())
      .map(norm)
      .filter(Boolean);

    const sel = norm(selectedRaw);
    return parts.includes(sel) || parts.includes(norm(ALT_SHOW_ALL)) || parts.includes("common");
  }

  // ✅ IMPORTANT: return actual swiper slides so hiding doesn't break gallery
  function getSlides() {
    const swiperSlides = Array.from(document.querySelectorAll(".swiper-slide"));
    if (swiperSlides.length) return swiperSlides;

    // fallback (if theme doesn't use swiper-slide)
    return Array.from(document.querySelectorAll(".m-product-media--item"));
  }

  function refreshSwiper() {
    const containers = document.querySelectorAll(
      ".swiper, .swiper-container, .main-swiper-container, .nav-swiper-container"
    );

    containers.forEach((sw) => {
      const inst = sw.swiper;
      if (inst && typeof inst.update === "function") {
        try {
          inst.updateSlides?.();
          inst.updateProgress?.();
          inst.updateSlidesClasses?.();
          inst.update();

          const slides = Array.from(sw.querySelectorAll(".swiper-slide"));
          const firstVisibleIdx = slides.findIndex((s) => s.style.display !== "none");
          if (firstVisibleIdx !== -1) {
            inst.slideTo(firstVisibleIdx, 0);
          } else {
            inst.slideTo(0, 0);
          }
        } catch (e) {}
      }
    });

    // Sync active state on first visible thumbnail
    const thumbSlides = Array.from(
      document.querySelectorAll(
        ".nav-swiper-container .swiper-slide, .m-product-media--slider__thumbnails .swiper-slide"
      )
    );
    const visibleThumbs = thumbSlides.filter((t) => t.style.display !== "none");
    if (visibleThumbs.length) {
      thumbSlides.forEach((t) => t.classList.remove("swiper-slide-thumb-active", "active"));
      visibleThumbs[0].classList.add("swiper-slide-thumb-active", "active");
    }
  }

  function filterSlides() {
    const variantId = getSelectedVariantId();
    const selectedColor = getSelectedColor();
    dlog("Selected:", { variantId, selectedColor });

    if (!selectedColor) return;

    const slides = getSlides();
    dlog("Slides found:", slides.length);
    if (!slides.length) return;

    let strictMatches = 0;

    slides.forEach((slide, i) => {
      const isVideo = isVideoSlide(slide);

      // In your theme, data-media-alt lives on .m-product-media or slide itself
      const mediaEl =
        slide.querySelector(".m-product-media[data-media-alt]") ||
        slide.querySelector("[data-media-alt]");

      const alt =
        slide.getAttribute("data-media-alt") ||
        mediaEl?.getAttribute("data-media-alt") ||
        "";

      // Videos are common across all variants, or alt matches selected color
      const show = isVideo || altMatches(alt, selectedColor);

      // strict match count (only count variant-specific images)
      if (!isVideo) {
        const parts = alt.split("|").map((s) => s.trim()).map(norm);
        if (parts.includes(norm(selectedColor))) strictMatches++;
      }

      // ✅ hide the wrapper slide itself (swiper-slide)
      slide.style.display = show ? "" : "none";

      if (DEBUG && i < 6) dlog(`slide ${i}`, { alt, isVideo, show });
    });

    dlog("Strict matches:", strictMatches);

    // Safety fallback: if NO matches, show all so gallery never breaks
    if (strictMatches === 0) {
      slides.forEach((slide) => (slide.style.display = ""));
    }

    refreshSwiper();
  }

  function hookVariantChanges() {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!idInput) return;

    let last = idInput.value;

    setInterval(() => {
      const cur = idInput.value;
      if (cur !== last) {
        last = cur;
        setTimeout(filterSlides, 120);
      }
    }, 250);
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Run multiple times because Horizon loads gallery/swiper async
    filterSlides();
    setTimeout(filterSlides, 300);
    setTimeout(filterSlides, 900);
    setTimeout(filterSlides, 1500);

    document.addEventListener("change", () => setTimeout(filterSlides, 120));
    document.addEventListener("click", () => setTimeout(filterSlides, 120));

    hookVariantChanges();
  });
})();
